export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 opacity-[0.07]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'radial-gradient(ellipse at 30% 50%, oklch(0.68 0.19 80 / 0.15) 0%, transparent 60%), radial-gradient(ellipse at 70% 40%, oklch(0.56 0.24 18 / 0.12) 0%, transparent 50%)',
          }}
        />
      </div>

      <div className="absolute top-0 right-0 w-[500px] h-[500px] md:w-[700px] md:h-[700px] opacity-[0.04] pointer-events-none">
        <div
          className="w-full h-full"
          style={{
            backgroundImage:
              'repeating-linear-gradient(0deg, oklch(0.68 0.19 80 / 0.5), oklch(0.68 0.19 80 / 0.5) 1px, transparent 1px, transparent 40px), repeating-linear-gradient(90deg, oklch(0.68 0.19 80 / 0.5), oklch(0.68 0.19 80 / 0.5) 1px, transparent 1px, transparent 40px)',
          }}
        />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full pt-20 md:pt-24 lg:pt-0">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500/15 text-accent-400 border border-accent-500/20 mb-4 whitespace-nowrap">
              全网热门影视 · 每日更新
            </span>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-50 leading-tight mb-3 md:mb-4">
              桃子影院 · 你的专属在线影院
            </h1>

            <p className="text-sm md:text-base text-primary-400 font-medium mb-4 md:mb-5">
              高清超清蓝光4K，永久免费不缓冲
            </p>

            <p className="text-sm md:text-base text-foreground-200 leading-relaxed max-w-xl mb-6">
              桃子影院汇聚海量电影大全，覆盖最新电影、热门电影排行榜与经典华语电影，支持高清超清蓝光4K多画质秒开播放。每日更新片源，不卡顿不缓冲，无论电脑手机都能流畅在线观看，打造极致的免费观影体验。
            </p>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mb-6 md:mb-8">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-500/15">
                  <i className="ri-film-line text-primary-400 text-base"></i>
                </span>
                <div>
                  <div className="text-sm md:text-base font-bold text-foreground-50">10万+</div>
                  <div className="text-xs text-foreground-400">影片资源</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-accent-500/15">
                  <i className="ri-flashlight-line text-accent-400 text-base"></i>
                </span>
                <div>
                  <div className="text-sm md:text-base font-bold text-foreground-50">秒开播放</div>
                  <div className="text-xs text-foreground-400">不卡顿不缓冲</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-500/15">
                  <i className="ri-4k-line text-primary-400 text-base"></i>
                </span>
                <div>
                  <div className="text-sm md:text-base font-bold text-foreground-50">4K蓝光</div>
                  <div className="text-xs text-foreground-400">多清晰度可选</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观影
              </a>
              <a
                href="#about"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-background-300 text-foreground-100 font-medium text-sm hover:border-primary-500/40 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[360px] md:w-[360px] md:h-[460px] rounded-2xl overflow-hidden bg-background-100 border border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20floating%20film%20reel%20and%20glowing%20golden%20light%20particles%2C%20abstract%20movie%20theater%20vibe%2C%20dramatic%20warm%20amber%20spotlight%20on%20dark%20background%2C%20luxurious%20velvet%20curtain%20texture%20in%20deep%20red%20accents%2C%20cinematic%20composition%2C%20elegant%20and%20atmospheric%2C%20high%20contrast%2C%20film%20noir%20aesthetic&width=720&height=920&seq=hero-cinema-main&orientation=portrait"
                alt="桃子影院 · 电影主题视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center gap-2 text-xs text-foreground-100">
                  <span className="px-2 py-1 rounded bg-accent-500/20 text-accent-300 text-xs font-medium">4K蓝光</span>
                  <span className="px-2 py-1 rounded bg-primary-500/20 text-primary-300 text-xs font-medium">秒开不缓冲</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}